import { format } from "date-fns";

export function isVisibleStudentGroup(membership) {
  return !!membership && !membership.canceled_at && membership.status !== "Replaced";
}

export function studentGroupStatus(membership, today = format(new Date(), "yyyy-MM-dd")) {
  if (membership.status === "Inactive") return "Inactive";
  if (membership.status === "Replaced") return "Replaced";
  if (membership.start_date > today) return "Not started";
  if (membership.end_date && membership.end_date <= today) return "Transferred";
  if (membership.start_date && membership.start_date <= today) return "Active";
  return membership.status || "Not defined";
}
